import { LinkTargetType } from '../components/base/outline-link/config';

// Check if URL is internal or external.
export function getUrlTarget(
  url: string,
  linkTarget: LinkTargetType
): LinkTargetType {
  // If the link target is defined, the same is returned.
  if (linkTarget) {
    return linkTarget;
  }
  // Custom validation.
  if (isInternal(url)) {
    return '_self';
  }
  return '_blank';
}

function isInternal(url: string, origin = location.origin): boolean {
  // null, undefined or empty
  if (url == null || url === '') {
    return true;
  }

  const ORIGIN_EXPRESSION = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
  const compareStrings = (a: string, b: string) =>
    a.toLowerCase() === b.toLowerCase();
  const match = url.match(ORIGIN_EXPRESSION);
  if (match) {
    // web page origin === indicated url origin
    return compareStrings(origin, match[0]);
  }
  return true;
}
